import { del, get, post, post2, put, put2 } from "./AuthType/api_helper";
import * as url from "./url_helper";
export const Api_url = "/api";

export const parentLogin = (data) => post(url.POST_PARENTLOGIN, data);
export const userLogin = (data) => post(url.POST_USERLOGIN, data);
export const verifyToken = (data) => post(url.VERIFY_TOKEN, data);
export const clearToken = () => post(url.CLEAR_TOKEN);
export const forgotPassword = (data) => post(url.FORGOT_PASSWORD, data);
export const forgotVerifyOTP = (data) => post(url.FORGOTVERIFY, data);
export const resetPassword = (data) => post(url.RESET_PASSWORD, data);
export const parentForgotPassword = (data) =>
  post(url.PARENT_FORGOT_PASSWORD, data);
export const parentResetPassword = (data) =>
  post(url.PARENT_RESET_PASSWORD, data);
export const changePassword = (email, data) =>
  put(`${url.CHANGE_PASSWORD}/${email}`, data);
export const parentChangePassword = (primary_mail_id, data) =>
  put(`${url.PARENT_CHANGE_PASSWORD}/${primary_mail_id}`, data);

// export const userLogout = (data) =>
//   api.post(url.USER_LOGOUT, data).then((response) => response.data);
// export const parentLogout = (data) =>
//   api.post(url.PARENT_LOGOUT, data).then((response) => response.data);
export const userLogout = (data) => post(url.USER_LOGOUT, data);
export const parentLogout = (data) => post(url.PARENT_LOGOUT, data);

// Centre
export const createCentre = (data) => post(url.CREATE_CENTRE, data);
export const getAllCentre = () => get(url.GET_ALL_CENTRE);
export const getCentreById = (center_id) =>
  get(`${url.GET_CENTRE_BY_ID}/${center_id}`);
export const updateCentreById = (center_id, data) =>
  put(`${url.UPDATE_CENTRE_BY_ID}/${center_id}`, data);
export const deleteCentreById = (id) => del(`${url.DELETE_CENTRE_BY_ID}/${id}`);

// programtype
export const createProgramType = (data) => post(url.CREATE_PROGRAM_TYPE, data);
export const getAllProgramType = () => get(url.GET_ALL_PROGRAM_TYPE);
export const getProgramTypeById = (program_id) =>
  get(`${url.GET_PROGRAM_TYPE_BY_ID}/${program_id}`);
export const updateProgramTypeById = (program_id, data) =>
  put(`${url.UPDATE_PROGRAM_TYPE_BY_ID}/${program_id}`, data);
export const deleteProgramTypeById = (id) =>
  del(`${url.DELETE_PROGRAM_TYPE_BY_ID}/${id}`);

// student
export const createStudent = (data) => post2(url.CREATE_STUDENT, data);
export const getAllStudentData = () => get(url.GET_ALL_STUDENT_DATA);
export const getAllStudentDataWithPagination = (params = {}) =>
  get(url.GET_ALL_STUDENT_DATA_WITH_PAGINATION, { params });

export const getStudentDataById = (id) =>
  get(`${url.GET_STUDENT_DATA_BY_ID}/${id}`);
export const getStudentByPrimaryID = (primary_mail_id) => {
  if (!primary_mail_id) {
    console.error("Error: primary_mail_id is undefined or null");
    return Promise.reject(new Error("primary_mail_id is required"));
  }
  const sanitizedEmail = primary_mail_id.replace(/"/g, "");

  // console.log("Fetching student by email:", sanitizedEmail);
  return get(`${url.GET_STUDENT_BY_PRIMARYEMAILID}/${sanitizedEmail}`);
};
export const updateStudentById = (student_id, data) =>
  put2(`${url.UPDATE_STUDENT}/${student_id}`, data);
export const getFeesByProgramType = (student_id) =>
  get(`${url.GET_FEES_BY_PROGRAM_TYPE}/${student_id}`);
export const deleteStudentById = (student_id, data) =>
  put(`${url.DELETE_Student_BY_ID}/${student_id}`, data);
export const updateStudentRegistrationById = (student_id, data) =>
  put2(`${url.UPDATE_STUDENT_REGISTRATION_BY_ID}/${student_id}`, data);
export const updateStudentRegistrationExistingById = (student_id, data) =>
  put2(`${url.UPDATE_OBSERVATION_BY_EXISTING_PARENT}/${student_id}`, data);
export const deleteMultipleStudentById = (studentIds, data) =>
  put(`${url.DELETE_MULTIPLE_STUDENT_BY_ID}`, { student_ids: studentIds, ...data });

export const updateAdmissionStatusReason = (student_id, data) =>
  put(`${url.UPDATE_STUDENT_ADMISSION_REASON}/${student_id}`, data);

// export const getStudentByMentorId = () => get(url.GET_ALL_STUDENT_DATA_BY_MENTORID)

export const getStudentByMentorId = (mentor_id) =>
  get(`${url.GET_ALL_STUDENT_DATA_BY_MENTORID}/${mentor_id}`);
export const getStudentNameByCenter = (center_id) =>
  get(`${url.STUDENT_BY_CENTER_ID}/${center_id}`);

// getcount from student admin
export const getCountByCategory = (academicYear) =>
  get(`${url.GET_COUNT_BY_CATEGORY}/${academicYear}`);
export const getCountByCenter = (academicYear) =>
  get(`${url.GET_COUNT_BY_CENTER}/${academicYear}`);
export const getCountByCluster = () => get(url.GET_COUNT_BY_CLUSTER);
export const getCountByProgramType = (academicYear) =>
  get(`${url.GET_COUNT_BY_PROGRAM_TYPE}/${academicYear}`);
export const getCountByStudent = (academicYear) =>
  get(`${url.GET_COUNT_BY_STUDENT}/${academicYear}`);
export const getCountBySplitPayment = () => get(url.GET_COUNT_BY_SPLIT_PAYMENT);
export const getActiveStudentCount = () =>
  get(`${url.GET_ACTIVE_STUDENT_COUNT}`);
export const getInActiveStudent = () =>
  get(`${url.GET_INACTIVE_STUDENT_COUNT}`);
export const getCountByPayment = (academicYear) =>
  get(`${url.GET_COUNT_BY_PAYMENT}/${academicYear}`);

export const getFullPaidCount = (academicYear) =>
  get(`${url.GET_FULL_PAID_COUNT}/${academicYear}`);
export const getFullUnPaidCount = (academicYear) =>
  get(`${url.GET_FULL_UNPAID_COUNT}/${academicYear}`);
export const getInstallmentPaidCount = () =>
  get(url.GET_INSTALLMENT_COUNT_PAID);
export const getInstallmentUnPaidCount = () =>
  get(url.GET_INSTALLMENT_COUNT_UNPAID);
export const getFullTermPaidAndPaidCount = (academicYear) =>
  get(`${url.GET_FULL_TERM_PAID_UNPAID_COUNT}/${academicYear}`);
  
export const bulkUpdateReRegistrationFee = (data) =>
  post(url.BULK_ALLOCATE_RE_REGISTRATION_TYPE, data);

// SMPT Detail
export const getSMTPDetail = () => get(url.GET_SMTP_DETAIL);
export const updateSMTPDetails = (id, data) =>
  put(`${url.UPDATE_SMTP_DETAIL}/${id}`, data);

// Cluster
export const getAllCluster = () => get(url.GET_ALL_CLUSTER);
export const getClusterById = (id) => get(`${url.GET_CLUSTER_BY_ID}/${id}`);
export const createCluster = (data) => post(url.CREATE_CLUSTER, data);
export const updateCluster = (id, data) =>
  put(`${url.UPDATE_CLUSTER}/${id}`, data);
export const deleteClusterById = (id) =>
  del(`${url.DELETE_CLUSTER_BY_ID}/${id}`);

// discount
export const createDiscount = (data) => post(url.CREATE_DISCOUNT, data);
export const getAllDiscount = () => get(url.GET_ALL_DISCOUNT);
export const getDiscountById = (discount_id) =>
  get(`${url.GET_DISCOUNT_BY_ID}/${discount_id}`);
export const updateDiscountById = (discount_id, data) =>
  put(`${url.UPDATE_DISCOUNT_BY_ID}/${discount_id}`, data);
export const deleteDiscountById = (discount_id) =>
  del(`${url.DELETE_DISCOUNT_BY_ID}/${discount_id}`);
export const getDiscountStudents = (discount_id) =>
  get(`${url.GET_DISCOUNT_STUDENTS}/${discount_id}`);
export const bulkAllocateDiscount = (data) =>
  post(url.BULK_ALLOCATE_DISCOUNT, data);
export const bulkUnAllocateDiscount = (data) =>
  post(url.BULK_UN_ALLOCATE_DISCOUNT, data);
export const getAllStudentDiscountWithPagination = (params = {}) => get(url.GET_ALL_STUDENT_DISCOUNT, { params });
export const getOnlyStudentDiscountWithPagination = (params = {}) => get(url.GET_ONLY_STUDENT_DISCOUNT, { params });

// Category
export const getAllCategory = () => get(url.GET_ALL_CATEGORY);
export const getCategoryById = (id) => get(`${url.GET_CATEGORY_BY_ID}/${id}`);
export const createCategory = (data) => post(url.CREATE_CATEGORY, data);
export const updateCategory = (id, data) =>
  put(`${url.UPDATE_CATEGORY}/${id}`, data);
export const deleteCategoryById = (id) =>
  del(`${url.DELETE_CATEGORY_BY_ID}/${id}`);

// users
// export const getAllUsers = (user_id) => get(url.GET_USERS_BY_ID);
export const getUsersById = (user_id) =>
  get(`${url.GET_USERS_BY_ID}/${user_id}`);
export const updateUsersById = (user_id, data) =>
  put(`${url.UPDATE_USERS_BY_ID}/${user_id}`, data);
export const sendUserResetPassword = (user_id) => {
  return post(`${url.SEND_USER_RESET_PASSWORD}`, { user_ids: user_id }); 
};

// parents
export const createParent = (data) => post(url.CREATE_PARENT, data);
export const getParentById = (parent_id) =>
  get(`${url.GET_PARENT_BY_ID}/${parent_id}`);
export const updateParentById = (parent_id, data) =>
  put(`${url.UPDATE_PARENT_BY_ID}/${parent_id}`, data);
export const updateAllPassword = (parent_id, data) =>
  put(`${url.UPDATE_ALL_PASSWORD}/${parent_id}`, data);
export const getAllParents = () => get(url.GET_ALL_PARENTS);
export const getAllParentsName = () => get(url.GET_ALL_PARENTS_NAME);
export const updateIsLateFee = (studentIds, data) =>
  put(`${url.UPDATE_LATE_FEE}/${studentIds}`, data);
export const updateIsTermFee = (studentIds, data) =>
  put(`${url.UPDATE_TERM_LATE_FEE}/${studentIds}`, data);
export const updateStudentFlags = (studentId, data) =>
  put(`${url.UPDATE_STUDENT_FLAGS}/${studentId}`, data);

export const deleteParentById = (parent_id, data) =>
  put(`${url.DELETE_PARENT_BY_ID}/${parent_id}`, data);
// backend_helper.js
export const deleteMultipleParentById = (parentIds, data) =>
  put(`${url.DELETE_MULTIPLE_PARENT_BY_ID}`, { parent_ids: parentIds, ...data });
export const sendResetPassword = (parent_id) => {
  return post(`${url.SEND_RESET_PASSWORD}`, { parent_ids: parent_id }); 
};
export const getAllParentsPagination = (params = {}) =>
  get(url.GET_ALL_PARENTS_PAGINATION, { params });

// Fees structure
export const createFeeStructure = (data) =>
  post(url.CREATE_FEES_STUCTURE, data);
export const getAllFeeStructure = () => get(url.GET_ALL_FEES_STUCTURE);
export const getFeeStructureById = (fee_structure_id) =>
  get(`${url.GET_FEES_STUCTURE_BY_ID}/${fee_structure_id}`);
export const updateFeeStructureById = (fee_structure_id, data) =>
  put(`${url.UPDATE_FEES_STUCTURE_BY_ID}/${fee_structure_id}`, data);
export const getFeeStructureByStudentId = (student_id) =>
  get(`${url.GET_FEES_STURCTURE_BY_STUDENT_ID}/${student_id}`);
export const deleteFeeStructureByID = (fee_structure_id) =>
  del(`${url.DELETE_FEES_STUCTURE_BY_ID}/${fee_structure_id}`);
export const getFeeStructureByStudentIdProgramCenterAcademic = (
  program_id,student_id,
  academic_year
) =>
  get(
    `${url.GET_FEES_STRUCTURE_BY_PROGRAM_CENTER_ACADEMIC}/${program_id}/${student_id}/${academic_year}`
  );

//roles
export const getRoleById = (role_id) =>
  get(`${url.GET_ROLES_BY_ID}/${role_id}`);
export const updateRolesById = (role_id) =>
  put(`${url.UPDATE_ROLES_BY_ID}/${role_id}`);

export const getAllRoles = () => get(url.GET_ALL_ROLES);

// Academic Year
export const getAllAcadamic = () => get(url.GET_ALL_ACADEMIC);
export const getAllMasterData= () => get(url.GET_ALL_MASETER_DATA);

export const getAcadamicById = (id) => get(`${url.GET_ACADEMIC_BY_ID}/${id}`);
export const createAcadamic = (data) => post(url.CREATE_ACADEMIC, data);
export const updateAcadamicYear = (id, data) =>
  put(`${url.UPDATE_ACADEMIC_YEAR}/${id}`, data);

export const deleteAcadamicYearByID = (id) =>
  del(`${url.DELETE_ACADEMIC_BY_ID}/${id}`);

export const getAllFeeTerm = (student_id) =>
  get(`${url.GET_ALL_FEE_TERM}/${student_id}`);
export const getFeeTermsForStudent = (student_id) =>
  get(`${url.GET_FEE_TERMS_FOR_STUDENT}/${student_id}`);

// payment
export const createPayment = (data) => post(url.CREATE_PAYMENT, data);
export const getAllPayment = () => get(url.GET_ALL_PAYMENT);
export const getPaymentById = (id) => get(`${url.GET_PAYMENT_BY_ID}/${id}`);
export const updatePaymentById = (id, data) =>
  put(`${url.UPDATE_PAYMENT_BY_ID}/${id}`, data);
export const deletePaymentById = (id) =>
  del(`${url.DELETE_PAYMENT_BY_ID}/${id}`);

// bulk allocate
export const bulkAllocatePayment = (data) =>
  post(url.BULK_ALLOCATE_PAYMENT, data);

// users
export const createUser = (data) => post(url.CREATE_USER, data);
export const getAllUser = () => get(url.GET_ALL_USER);
export const getUserById = (user_id) => get(`${url.GET_USER_BY_ID}/${user_id}`);
export const updateUserById = (user_id, data) =>
  put(`${url.UPDATE_USER_BY_ID}/${user_id}`, data);
export const deleteUserById = (user_id) =>
  del(`${url.DELETE_USER_BY_ID}/${user_id}`);

// user-mapping
export const createUserMapping = (data) => post(url.CREATE_USER_MAPPING, data);
export const getAllUserMapping = () => get(url.GET_ALL_USER_MAPPING);
export const getUserByIdMapping = (id) =>
  get(`${url.GET_USER_BY_ID_MAPPING}/${id}`);
export const updateUserByIdMapping = (id, data) =>
  put(`${url.UPDATE_USER_BY_ID_MAPPING}/${id}`, data);
export const deleteUserByIdMapping = (id) =>
  del(`${url.DELETE_USER_BY_ID_MAPPING}/${id}`);

// fee-paid
export const createFeePaid = (data) => post2(url.CREATE_FEES_PAID, data);
export const createFeePaidAdmin = (data) => post2(url.CREATE_FEES_PAID_ADMIN, data);
export const getAllFeePaid = () => get(url.GET_ALL_FEES_PAID);
export const getDiscountByStudentId = (student_id) =>
  get(`${url.GET_DISCOUNT_BY_STUDENT_ID}/${student_id}`);
export const getFeesPaidStudentId = (student_id,order_id) =>
  get(`${url.GET_FEES_PAID_BY_STATUS_CODE}/${student_id}/${order_id}`);
export const getFeesPaidStudentIdForOtherCharge = (student_id) =>
  get(`${url.GET_FEES_PAID_BY_STATUS_CODE_FOR_OTHER_CHARGE}/${student_id}`);

export const getTodayFees = () => get(url.GET_TODAY_FEES);
export const getThisWeekFees = () => get(url.GET_THIS_WEEK_FEES);
export const getThisMonthFees = () => get(url.GET_THIS_MONTH_FEES);
export const getThisYearFees = () => get(url.GET_THIS_YEAR_FEES);
export const updateFeePaidById = (payment_id, data) =>
  put(`${url.UPDATE_FEES_PAID}/${payment_id}`, data);
export const updateFeePaidByOrderId = (order_id, data) =>
  put(`${url.UPDATE_FEES_PAID_ORDER_ID}/${order_id}`, data);
export const getAllFeePaidDetails = () => 
  get(url.GET_ALL_FEES_PAID_DETAILS);
export const getAdminFeePaidDetails = () => 
  get(url.GET_ADMIN_FEES_PAID_DETAILS);
export const getFeesPaidById = (student_id) =>
  get(`${url.GET_FEES_PAID_BY_ID}/${student_id}`);

// centerprogramrmapping
export const createCenterProgramMapping = (data) =>
  post(url.CREATE_CENTER_PROGRAM_MAPPING, data);
export const getAllCenterProgramMapping = () =>
  get(url.GET_ALL_CENTER_PROGRAM_MAPPING);
export const getCenterProgramMappingByCenterId = (center_id) =>
  get(`${url.GET_CENTER_PROGRAM_MAPPING_BY_CENTER_ID}/${center_id}`);
export const updateCenterProgramMappingById = (center_id, data) =>
  put(`${url.UPDATE_CENTER_PROGRAM_MAPPING}/${center_id}`, data);

// centercategorymapping
export const createCenterCategoryMapping = (data) =>
  post(url.CREATE_CENTER_CATEGORY_MAPPING, data);
export const getAllCenterCategoryMapping = () =>
  get(url.GET_ALL_CENTER_CATEGORY_MAPPING);
export const getCenterCategoryMappingByCenterId = (center_id) =>
  get(`${url.GET_CENTER_CATEGORY_MAPPING_BY_CENTER_ID}/${center_id}`);
export const updateCenterCategoryMappingById = (center_id, data) =>
  put(`${url.UPDATE_CENTER_CATEGORY_MAPPING}/${center_id}`, data);

// centerclustermapping
export const createCenterClusterMapping = (data) =>
  post(url.CREATE_CENTER_CLUSTER_MAPPING, data);
export const getAllCenterClusterMapping = () =>
  get(url.GET_ALL_CENTER_CLUSTER_MAPPING);
export const getCenterClusterMappingByCenterId = (center_id) =>
  get(`${url.GET_CENTER_CLUSTER_MAPPING_BY_CENTER_ID}/${center_id}`);
export const updateCenterClusterMappingById = (center_id, data) =>
  put(`${url.UPDATE_CENTER_CLUSTER_MAPPING}/${center_id}`, data);

// center-based display cluster, program type, category
export const getClusterProgramCategoryByCenter = (center_id) =>
  get(`${url.GET_CLUSTER_PROGRAM_CATEGORY_BY_CENTER}/${center_id}`);

// installment count
export const getInstallmentPaidAndUnpaidCount = (academicYear) =>
  get(`${url.GET_INSTALLMENT_COUNT_PAID_AND_UNPAID}/${academicYear}`);

// getcount from student center head
export const fetchActiveStudentCount = (userId, roleId) =>
  get(`${url.CENTER_HEAD_ACTIVE_STUDENT_COUNT}/${userId}/${roleId}`);
export const fetchFullPaidCount = (userId, roleId, academicYear = null) =>
  get(
    `${url.CENTER_HEAD_FULL_PAID_FEES}/${userId}/${roleId}${
      academicYear !== null && academicYear !== undefined
        ? `/${academicYear}`
        : ""
    }`
  );
export const fetchFullUnpaidCount = (userId, roleId, academicYear) =>
  get(
    `${url.CENTER_HEAD_FULL_UNPAID_FEES}/${userId}/${roleId}/${academicYear}`
  );
export const fetchInstallmentPaidCount = (userId, roleId, academicYear) =>
  get(`${url.CENTER_HEAD_TERM_PAID_FEES}/${userId}/${roleId}/${academicYear}`);
export const fetchInstallmentUnpaidCount = (
  userId,
  roleId,
  academicYear = null
) =>
  get(
    `${url.CENTER_HEAD_TERM_UNPAID_FEES}/${userId}/${roleId}${
      academicYear !== null && academicYear !== undefined
        ? `/${academicYear}`
        : ""
    }`
  );

export const fetchCategoryProgramClusterCountByCenterHead = (
  userId,
  roleId,
  academicYear
) =>
  get(
    `${url.CENTER_HEAD_COUNT_BY_CATEGORY_PROGRAM_CLUSTER}/${userId}/${roleId}/${academicYear}`
  );

//ccavenue
export const postPaymentToCCAvenue = (data) =>
  post(url.POST_CCAVENUE_ORDER, data);
export const 

initiatePaymentToCCAvenue = (data) =>
  post(url.GET_CCAVENUE_ORDER, data); // ✅ Use POST instead of GET

// fee type
export const createFeeType = (data) => post(url.CREATE_FEE_TYPE, data);
export const getAllFeeType = () => get(url.GET_ALL_FEE_TYPE);
export const getFeeTypeById = (fees_type_id) =>
  get(`${url.GET_FEE_TYPE_ID}/${fees_type_id}`);
export const updateFeeTypeById = (fees_type_id, data) =>
  put(`${url.UPDATE_FEE_TYPE_ID}/${fees_type_id}`, data);
export const deleteFeeTypeById = (fees_type_id) =>
  del(`${url.DELETE_FEE_TYPE_ID}/${fees_type_id}`);
export const bulkAllocateFeeType = (data) =>
  post(url.BULK_ALLOCATE_FEE_TYPE, data);
export const bulkUnallocateFeeType = (data) =>
  post(url.BULK_UNALLOCATE_FEE_TYPE, data);


// notification
export const getAllNotification = () => get(url.GET_ALL_NOTIFICATION);
export const createNotification = (data) => post(url.CREATE_NOTIFICATION, data);
export const updateNotification = (notification_id, data) =>
  put(`${url.UPDATE_NOTIFICATION}/${notification_id}`, data);

// reminder
export const createReminder = (data) => post(url.CREATE_REMINDER, data);
export const getReminder = (center_id) =>
  get(`${url.GET_REMINDER}/${center_id}`);
export const updateReminder = (reminder_id, data) =>
  put(`${url.UPDATE_REMINDER}/${reminder_id}`, data);
export const deleteReminder = (reminder_id) =>
  del(`${url.DELETE_REMINDER}/${reminder_id}`);

// bank account details
export const createBankAccount = (data) => post(url.CREATE_BANK_ACCOUNT, data);
export const getAllBankAccounts = () => get(url.GET_ALL_BANK_ACCOUNTS);
export const getBankAccountById = (id) =>
  get(`${url.GET_BANK_ACCOUNT_BY_ID}/${id}`);
export const updateBankAccountById = (id, data) =>
  put(`${url.UPDATE_BANK_ACCOUNT_BY_ID}/${id}`, data);
export const deleteBankAccountById = (id) =>
  del(`${url.DELETE_BANK_ACCOUNT_BY_ID}/${id}`);

// student Registration  and observation
export const createStudentRegistration = (data) =>
  post2(url.CREATE_STUDENT_REGISTRATION, data);
export const getAllStudentRegistrations = () =>
  get(url.GET_ALL_STUDENT_REGISTRATIONS);
export const getStudentRegistrationById = (id, token) => {
  if (!id || !token) {
    throw new Error("ID and token are required");
  }
  const encodedToken = encodeURIComponent(token);
  return get(`${url.GET_STUDENT_REGISTRATION_BY_ID}/${id}/${encodedToken}`);
};

export const getStudentRegistrationRecordById = (id) =>
  get(`${url.GET_STUDENT_REGISTRATION_RECORD_BY_ID}/${id}`);

export const deleteStudentRegistrationById = (id, data) =>
  put(`${url.DELETE_STUDENT_REGISTRATION_BY_ID}/${id}`, data);
export const createParentRegistration = (data) =>
  post(url.CREATE_PARENT_REGISTRATION, data);
export const updateStudentRegistrationObservationId = (id, userId, data) =>
  put(
    `${url.UPDATE_STUDENT_REGISTRATION_OBSERVATION_ID}/${id}/${userId}`,
    data
  );
export const getAllStudentObservationDetails = () =>
  get(url.GET_ALL_STUDENT_OBSERVATION_DETAILS);
export const admitAsStudent = (id, data) =>
  put(`${url.ADMIT_STUDENT}/${id}`, data);
export const sendApplicationToParent = (parent_id) =>
  get(`${url.SEND_APPLICATION_FORM_TO_PARENT}/${parent_id}`);
export const sendMultipleApplicationToParent = (studentIds) =>
 post(`${url.SEND_MULTIPLE_APPLICATION_FORM_TO_PARENT}`, { student_ids: studentIds });
export const deleteStudentObservation = (id) =>
  put(`${url.DELETE_STUDENT_OBSERVATION}/${id}`);
export const updateStudentObservationStatus = (id, data) =>
  put(
    `${url.UPDATE_STUDENT_OBSERVATION_STATUS}/${id}`,
    data
  );

//ccavenue Registration
export const postPaymentToCCAvenue2 = (data) =>
  post(url.POST_CCAVENUE_ORDER2, data);
export const initiatePaymentToCCAvenue2 = (data) =>
  post(url.GET_CCAVENUE_ORDER2, data); // ✅ Use POST instead of GET
export const initiatePaymentToCCAvenue3 = (data) =>
  post(url.GET_CCAVENUE_ORDER3, data); // ✅ Use POST instead of GET
export const postPaymentToCCAvenue3 = (data) =>
  post(url.POST_CCAVENUE_ORDER3, data);

// existingstudent register form
export const updateStudentBasicInfo = (student_id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (
      key !== "child_photo" &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key]);
    }
  });

  if (data.child_photo instanceof File) {
    formData.append("child_photo", data.child_photo);
  }

  return put(`${url.UPDATE_STUDENT_BASIC_INFO}/${student_id}`, formData);
};

export const updateEducationalViews = (student_id, data) => {
  return put(`${url.UPDATE_EDUCATIONAL_VIEWS}/${student_id}`, data);
};

export const updatePreferencesAndConsent = (student_id, data) => {
  return put(`${url.UPDATE_PREFERENCES_AND_CONSENT}/${student_id}`, data);
};

export const updateHealthAndBehavioralInfo = (student_id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (
      key !== "diagnosis_attachments" &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key]);
    }
  });
  if (Array.isArray(data.diagnosis_attachments)) {
    data.diagnosis_attachments.forEach((file) => {
      if (file instanceof File) {
        formData.append("diagnosis_attachments", file);
      }
    });
  }

  return put(
    `${url.UPDATE_HEALTH_AND_BEHAVIORAL_INFO}/${student_id}`,
    formData
  );
};

export const updateSchoolingAndBehavioralDetails = (student_id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (
      key !== "reports_assessments" &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key]);
    }
  });

  if (data.reports_assessments instanceof File) {
    formData.append("reports_assessments", data.reports_assessments);
  }

  return put(
    `${url.UPDATE_SCHOOLING_AND_BEHAVIORAL_DETAILS}/${student_id}`,
    formData
  );
};

export const UploadExitingChildPhoto = (student_id, data) =>
  put2(`${url.UPLOAD_PHOTO_EXITING_CHILD}/${student_id}`, data);
export const uploadExitingDiagnosisDocument = (student_id, data) =>
  put2(`${url.UPLOAD_DIAGNOSIS_DOCUMENT_EXITING_CHILD}/${student_id}`, data);
export const uploadExitingAssessmentDocument = (student_id, data) =>
  put2(`${url.UPLOAD_ASSESSMENT_DOCUMENT_EXITING_CHILD}/${student_id}`, data);

// newRegisterForm
export const updateNewStudentBasicInfo = (id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (
      key !== "child_photo" &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key]);
    }
  });

  if (data.child_photo instanceof File) {
    formData.append("child_photo", data.child_photo);
  }

  return put(`${url.UPDATE_NEW_STUDENT_BASIC_INFO}/${id}`, formData);
};

export const updateNewEducationalViews = (id, data) => {
  return put(`${url.UPDATE_NEW_EDUCATIONAL_VIEWS}/${id}`, data);
};

export const updateNewPreferencesAndConsent = (id, data) => {
  return put(`${url.UPDATE_NEW_PREFERENCES_AND_CONSENT}/${id}`, data);
};

export const updateNewHealthAndBehavioralInfo = (id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (
      key !== "diagnosis_attachments" &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key]);
    }
  });
  if (Array.isArray(data.diagnosis_attachments)) {
    data.diagnosis_attachments.forEach((file) => {
      if (file instanceof File) {
        formData.append("diagnosis_attachments", file);
      }
    });
  }

  return put(`${url.UPDATE_NEW_HEALTH_AND_BEHAVIORAL_INFO}/${id}`, formData);
};
export const updateNewSchoolingAndBehavioralDetailsForPrePrimary = (id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (
      key !== "reports_assessments" &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key]);
    }
  });

  if (data.reports_assessments instanceof File) {
    formData.append("reports_assessments", data.reports_assessments);
  }

  return put(
    `${url.UPDATE_NEW_SCHOOLING_AND_BEHAVIORAL_DETAILS_FOR_PRE_PRIMARY}/${id}`,
    formData
  );
};


export const updateNewSchoolingAndBehavioralDetails = (id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (
      key !== "reports_assessments" &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key]);
    }
  });

  if (data.reports_assessments instanceof File) {
    formData.append("reports_assessments", data.reports_assessments);
  }

  return put(
    `${url.UPDATE_NEW_SCHOOLING_AND_BEHAVIORAL_DETAILS}/${id}`,
    formData
  );
};

export const updateNewStudentPayment = (id, data) =>
  put(`${url.UPDATE_NEW_STUDENT_PAYMENT_PROCRESS}/${id}`, data);

export const UploadNewExitingChildPhoto = (id, data) =>
  put2(`${url.UPLOAD_NEW_PHOTO_EXITING_CHILD}/${id}`, data);
export const UploadObservationReport = (id, data,authUserId) =>
  put2(`${url.UPLOAD_OBSERVATION_REPORT}/${id}/${authUserId}`, data);
export const sendObservationToParent = (primary_mail_id,id) =>
 post(`${url.SEND_OBSERVATION_TO_PARENT}/${primary_mail_id}/${id}`);
export const uploadNewExitingDiagnosisDocument = (id, data) =>
  put2(`${url.UPLOAD_NEW_DIAGNOSIS_DOCUMENT_EXITING_CHILD}/${id}`, data);
export const uploadNewExitingAssessmentDocument = (id, data) =>
  put2(`${url.UPLOAD_NEW_ASSESSMENT_DOCUMENT_EXITING_CHILD}/${id}`, data);

// registeration fee paid
export const getAllRegistrationsFeesPaid = () =>
  get(url.GET_ALL_REGISTERATION_FEES_PAID);
export const getRegistrationFeePaidById = (id) =>
  get(`${url.GET_REGISTERATION_FEES_PAID_BY_ID}/${id}`);
export const getFeesPaidDetailsForObservationandRegistrationFeeByStudentId = (id) =>
  get(`${url.GET_OBSERATION_AND_REGISTERATION_FEES_PAID_BY_ID}/${id}`);

//late fee
export const getAllLateFees = () => get(url.GET_ALL_LATE_FEES);

export const postPaymentToCCAvenueType2 = (data) =>
  post(url.POST_CCAVENUE_ORDER_TYPE_2, data);
export const initiatePaymentToCCAvenueType2 = (data) =>
  post(url.GET_CCAVENUE_ORDER_TYPE_2, data);


export const create_fees_with_other_fees = (data) =>
  post2(url.CREATE_PAYMENT_FEES_OTHER_FEES, data);

// create-fee
// other_fees
// export const generateDueDates = (data) => get(`${url.GENERATE_DUE_DATE}?${data.toString()}` );
export const otherFeesPaydetails = (data) => get(`${url.OTHER_DETAILS_PAY_DETAILS}/${data.id.toString()}` );
export const allocatedStudentList = () => get(`${url.ALLOCATED_OTHER_FEES_STUDENTS}` );
export const getFeesDetails = (data) => get(`${url.FEES_DETAILS_PAY_DETAILS}/${data.toString()}` );


export const dueDateUpdate = (data) =>
  put(`${url.DUE_DATE_UPDATE}/${data.id}`, { due_date: data.due_date });

export const createPaymentType2FeeLogic = (data) =>
  post2(url.CREATE_PAYMENT_TYPE_2_FEE_LOGIC, data);


//pagination
export const getAllFeePaidPagination = (params) => 
  get(url.GET_ALL_FEES_PAID_PAGINATION, { params });
export const getAllAdminFeePaidPagination = (params) => 
  get(url.GET_ALL_ADMIN_FEES_PAID_PAGINATION, { params });
export const getAllStudentRegistrationsPagination = (params) =>
  get(url.GET_ALL_STUDENT_REGISTRATIONS_PAGINATION, {params});
export const getAllStudentObservationDetailsPagination = (params) =>
  get(url.GET_ALL_STUDENT_OBSERVATION_DETAILS_PAGINATION, {params});
export const getAllStudentsWithFeesPagination = (params) => 
  get(url.GET_ALL_STUDENT_WITH_FEES_PAGINATION, { params });



// get all students fee details
export const getPageStudentsFeeDetails = (academicYear, params = {}) => {
  let queryString = "";

  if (params && Object.keys(params).length > 0) {
    queryString =
      "?" +
      new URLSearchParams(
        Object.fromEntries(
          Object.entries(params).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        )
      ).toString();
  }

  return get(`${url.GET_PAGE_STUDENT_FEES_PAID_DETAILS}/${academicYear}${queryString}`);
};



export const getFinanceDashboardData = (params) =>
  get(`${url.FEES_SUMMARY}`, { params });

 
export const getOverDueSummary = (params = {}) =>
  get(url.GET_FEES_OVER_DUE_SUMMARY, { params });

export const getOverDueDetails = (params = {}) =>
  get(url.GET_FEES_OVER_DUE_DETAILS, { params });
  
export const tuitionFeesSummary = (params = {}) =>
  get(url.GET_TUITION_FEES__DETAILS, { params });

export const getFeesData = (params = {}) =>
  get(url.GET_FEES_STUDENT_DETAILS, { params });
  
export const getBirthdays = (params = {}) =>
  get(url.GET_BIRTHDAYS, { params });


export const getAllocatedOtherFeesStudents = (params = {}) =>
  get(url.GET_ALLOCATED_OTHER_FEES, { params });
export const getAppVersion = ( ) =>
  get(url.APP_VERSION, {  });

// get all students fee details
export const getAllStudentsFeeDetails = (academicYear) =>
  get(`${url.GET_ALL_STUDENT_FEES_PAID_DETAILS}/${academicYear}`);
